'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decorators = require('../utils/propTypes/decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Heading = (0, _styledComponents2.default)(function (props) {
  var Tag = props.tagName,
      rest = _objectWithoutProperties(props, ['tagName']);

  return _react2.default.createElement(Tag, rest);
}).withConfig({
  displayName: 'Heading'
})(['']);

Heading.propTypes = {
  'aria-level': _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6]),
  tagName: (0, _decorators.hidden)(_propTypes2.default.elementType.isRequired)
};

Heading.defaultProps = {
  'aria-level': 2,
  tagName: 'span'
};

exports.default = Heading;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/elements/Heading.js
// module id = 180
// module chunks = 177